import { runAnalyzer } from '../components/analyzer.js';
import { runReveal } from '../components/reveal.js';
import { renderCertificate } from '../components/certificate.js';
import { mountCertifyFriend } from '../components/certifyFriend.js';
import { getCert } from '../lib/api.js';
import { downloadPdf } from '../lib/pdf.js';
import { shareImage } from '../lib/image.js';

export async function renderShow(root, { certId, justCertified, durationMsOverride }) {
  // Fetch cert and run analyzer concurrently so analyzer DOM is visible immediately
  const certPromise = getCert(certId).catch(() => null);

  const analyzerPromise = runAnalyzer(root, {
    name: '',
    durationMs: durationMsOverride ?? 10000,
    onComplete: () => {},
  });

  const cert = await certPromise;

  if (!cert) {
    root.innerHTML = `<div class="forensic-page"><h1>Case file unavailable. Please retry.</h1></div>`;
    return;
  }

  await analyzerPromise;

  await runReveal(root, {
    name: cert.name,
    caseNumber: cert.caseNumber,
    revealLineId: cert.revealLineId,
    createdAt: cert.createdAt,
    durationMs: durationMsOverride ? 50 : 1200,
  });

  const certHost = document.createElement('div');
  certHost.className = 'cert-host';
  root.querySelector('.reveal-page').appendChild(certHost);
  renderCertificate(certHost, cert);

  certHost.querySelector('[data-test=download-pdf]').addEventListener('click', () => {
    downloadPdf(certHost.querySelector('.certificate'), cert);
  });
  certHost.querySelector('[data-test=share-image]').addEventListener('click', () => {
    shareImage(certHost.querySelector('.certificate'), cert);
  });
  certHost.querySelector('[data-test=order-printed]').addEventListener('click', () => {
    window.location.assign(`/checkout/${cert.id}`);
  });

  const friendBtn = certHost.querySelector('[data-test=certify-friend]');
  friendBtn.addEventListener('click', () => {
    if (certHost.querySelector('[data-test=certify-friend-form]')) return;
    const formHost = document.createElement('div');
    certHost.appendChild(formHost);
    mountCertifyFriend(formHost, { referrerId: cert.id });
  });
}
